import Vue from "vue";
import VueResource from "vue-resource";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import VConsole from "vconsole";
import { Api as Request, _global } from "./api/request";
import { Loading } from 'vant';
import 'vant/lib/index.css';

Vue.use(Loading);
// new VConsole();
Vue.use(VueResource);
Vue.config.productionTip = false;
window.Request = Request;
window._global = _global;
Vue.config.ignoredElements = ['wx-open-launch-weapp']

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
